/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/* eslint-env browser */

import FormatEnum from '../../../core/format-enum';
import UpdatePlatform from '../../../core/update/update-platform';
import Platform from '../../../platform/platform';

/**
 * Správce aplikace pro standardní webové technologie.
 * @implements {AppManager}
 * @memberof AdapterWeb
 */
class AppManager {
  /**
   * Vytvoří instanci.
   * @returns {AppManager} Nová instance.
   */
  constructor() {
    this.updateUrl = location.href;
  }

  /** @inheritdoc */
  exit() {
    return new Promise((resolve) => {
      location.href = 'about:blank';
      return resolve();
    });
  }

  /** @inheritdoc */
  finishUpdate() {
    return new Promise((resolve) => {
      location.href = this.updateUrl;
      return resolve();
    });
  }

  /** @inheritdoc */
  getBuildPlatform() {
    return Promise.resolve(Platform.Web);
  }

  /** @inheritdoc */
  getFormat() {
    return Promise.resolve(FormatEnum.HTML);
  }

  /** @inheritdoc */
  getRuntimePlatform() {
    return Promise.resolve(Platform.Web);
  }

  /** @inheritdoc */
  getUpdatePlatform() {
    // Web má jedinou platformu, bez verzování apod.
    return Promise.resolve(UpdatePlatform.Web);
  }

  /** @inheritdoc */
  getUpdateUrl() {
    return new Promise((resolve) => resolve(this.updateUrl));
  }

  /** @inheritdoc */
  update(url) {
    // Aktualizace se provede tak, že se nastaví URL pro update a na ni se pak přejde při restartu.
    // TODO #44 Update funguje jen napoprvné. Nelze nahradit zdroje.
    return new Promise((resolve) => {
      this.updateUrl = url;
      return resolve();
    });
  }
}

export default AppManager;
